import * as React from 'react';
import { Toast as FlowBiteToast } from 'flowbite-react';
import { cn, ToastType } from '@restworld/utils-common';
import { Button } from '@restworld/ui-ds-base';

interface IAppProps {
  message: string;
  title?: string;
  type?: ToastType;
}
export const InteractiveToast: React.FunctionComponent<IAppProps> = ({ message, title = '' }) => (
  <ToastWrapper>
    <div className="flex justify-between">
      <span className="text-sm font-semibold text-gray-900 dark:text-white">{title}</span>
      <FlowBiteToast.Toggle />
    </div>
    <div className="text-sm font-normal">{message}</div>
    <div className="flex gap-2">
      <Button size="sm" variant="primary">
        Continua senza CV
      </Button>
      <Button size="sm" variant="secondary-neutral">
        Not now
      </Button>
    </div>
  </ToastWrapper>
);

export default InteractiveToast;
const ToastWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-3 p-2 w-full', className)} {...props} />
);
